<template>
     
  <div class="px-2" style="{backgruond-color:white}">
    <HeaderBar/>
    <!-- search input -->
    <div class="d-flex flex-column mb-2 mt-4"> 
      <v-offline 
      online-class="online"
      offline-class="offline"
      @detected-condition="onConnectionChange">
          <template v-if="online">
          <div class="flex w-full h-full justify-center items-center text-6xl">
              
          </div>
          </template>
          <template v-if="!online">
          <div class="flex w-full h-full justify-center items-center text-6xl">
          Sin Conexión
          </div>
          </template>
      </v-offline>
    </div>
    <div class="d-flex justify-content-center mt-1 headTitle mt-4">
      
      Animales
    </div>
    <div class="d-flex justify-content-center mt-1 headTitle">
      {{fincaName}}
    </div>
    
    <!-- table -->
    
    <vue-good-table :columns="columns" :rows="rows" :rtl="direction"  styleClass="vgt-table bordered"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm
      }" 
      
      :pagination-options="{
        enabled: true,
        perPage: pageLength,
        mode:'records',
        nextLabel: ' Sig ',
        prevLabel: ' Ant ',
        perPageDropdown: [10, 20],
        dropdownAllowAll: false,
        rowsPerPageLabel: 'Registros por página',
        ofLabel: 'de',
        position: 'top',
        pageLabel: 'página',
      }"
      
      :sort-options="{
        enabled: true,
      }"

      @on-row-click="showModal"
    >
      <template slot="table-row" slot-scope="props">

        <!-- Column: Name -->
        <span v-if="props.column.field === 'sex'" class="text-center">
          <span v-if="props.row.sex===false" class="text-center">M</span>
          <span v-if="props.row.sex===true" class="text-center">H</span>
          
        </span>

        <!-- Column: Status -->
        <span v-else-if="props.column.field === 'status'">
          <b-badge :variant="statusVariant(props.row.status)">
            {{ props.row.status }}
          </b-badge>
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <!-- <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              Mostrando
            </span>
            <b-form-select v-model="pageLength" :options="['10', '50']" class="mx-1"
              @input="(value) => props.perPageChanged({ currentPerPage: value })" />
            <span class="text-nowrap">  de {{ props.total }} registros </span>
          </div>
        </div>
      </template> -->
    </vue-good-table>
    <div class="mt-2">
      <a @click="navigateTo('/basicHome/AnimalsStatus')"><strong>Ver animales inactivos</strong></a>
    </div>
    <b-modal centered v-model="modalShow" hide-footer hide-header>
      <div v-if="modalCase == 0">
        <div class="d-flex justify-content-end  ">
          <feather-icon @click="modalShow = !modalShow" icon="XIcon" size="20" />
        </div>
        <div class="d-flex align-items-center justify-content-center subTitle pt-2 ">Animales


        </div>
        <div class="linkTitle mt-5" @click="modalCase = 1">Datos Generales</div>
        <div class="linkTitle mt-2" @click="modalCase = 2">Evolucion Peso</div>
        <div class="linkTitle mt-2" @click="modalCase = 3">Datos Sanitarios</div>
        <div class="linkTitle mt-2 mb-5" @click="modalCase = 4">Datos Reproductivos</div>
      </div>


      <div v-if="modalCase == 1">
        <div class="d-flex justify-content-end  ">
          <feather-icon @click="modalShow = !modalShow" icon="XIcon" size="20" />
        </div>
        <div class="d-flex align-items-center justify-content-center subTitle pt-2">Datos Generales</div>
        <div class=" d-flex justify-content-end  border-bottom">
          <feather-icon @click="modalCase=5" icon="Edit2Icon" size="20" />
          <!-- <feather-icon class="" @click="modalTrashShow = !modalTrashShow" icon="TrashIcon" size="20" /> -->
        </div>
        <div class="d-flex align-items-center justify-content-center pt-2">
          <b-img :src="animalData.image_url" width="200"/>
        </div>
        <div class="d-flex align-items-center justify-content-center pt-2">
          {{animalData.number}} - {{animalData.name}}
        </div>
            
          
        <div class="d-flex justify-content-between mt-3 ">
          
          <div class="ml-2">Peso <p class="editModal">{{animalData.weight}}</p> </div> 
          <div class="mr-5 pr-3">Edad <br /><p class="editModal"> {{animalData.age}} </p></div>
        </div>
         <div class="mt-1 ml-2">Sexo <p v-if="animalData.sex===false" class="editModal"> Macho</p> <p v-if="animalData.sex===true" class="editModal"> Hembra</p></div>
         <!-- <div class="d-flex justify-content-center mb-5 mt-3">
          <b-img src="@/assets/images/ganImage/UpoladImage.png" ></b-img>
         </div> -->
      </div>
        <div v-if="modalCase==5">
         <div class="d-flex justify-content-end  ">
          <feather-icon @click="modalShow = !modalShow" icon="XIcon" size="20" />
        </div>
        <div class="d-flex align-items-center justify-content-center subTitle pt-2">Datos Generales</div>
          <div class="editAnimal mt-2"><strong>Animal:</strong> {{animalData.number}} - {{animalData.name}}</div>
          <div class="d-flex justify-content-center mt-2">

            <b-form-group class="w-25" label="Peso" label-for="weight">
                <b-form-input id="animal.weight" v-model="animal.weight" :value="animalData.weight" readonly="readonly"/>
            </b-form-group>
            <b-form-group class="w-75 ml-1" label="Edad" label-for="age">
                <b-form-input id="animal.age" v-model="animal.age" :value="animalData.age" />
            </b-form-group>
          </div>
          <b-form-group label="Sexo" label-for="sex">
            <div class="d-flex align-items-center justify-content-center">
              <div class="flex-column pt-0 mr-2">Macho</div>
                <div class="align-self-end mr-2">
                  <b-form-checkbox
                    v-model="animal.sex"
                    button-variant="#D7B92C"
                    class="custom-control-warning"
                    name="check-button"
                    switch
                  />
                  
                </div>
              <div class="flex-column">Hembra</div>
            </div>
          </b-form-group>
          
         
        <!--   <div class="d-flex justify-content-center  mt-2">
          <b-img src="@/assets/images/ganImage/UpoladImage.png" ></b-img>
          </div> -->
         
         <div class="d-flex justify-content-center  mt-2 mb-1"><b-button @click="updateAnimal" class="bg-primary w-50"> Guardar</b-button></div>
        
        </div>
         <!--////////////// -->
         <div v-if="modalCase == 2">
        <div class="d-flex justify-content-end  ">
          <feather-icon @click="modalShow = !modalShow" icon="XIcon" size="20" />
        </div>
        <div class="d-flex align-items-center justify-content-center subTitle pt-2">Evolucion Peso</div>
        <div class="editAnimal mt-2"><strong>Animal:</strong> {{animalData.number}} - {{animalData.name}}</div>
        <!-- <div class=" d-flex justify-content-end  border-bottom">
          <feather-icon  icon="PlusIcon" size="20" />
        </div> -->
        <div class="d-flex justify-content-between mt-3 ">
          <WheighinsLineChartVue

            :data="weighinsData"
            :options="chartOptions"
          />
        </div>
        
      </div>
        <!--////////////// -->
       <div v-if="modalCase == 3">
        <div class="d-flex justify-content-end  ">
          <feather-icon @click="modalShow = !modalShow" icon="XIcon" size="20" />
        </div>
        <div class="d-flex align-items-center justify-content-center subTitle pt-2">Datos Sanidad</div>
        <div class="editAnimal mt-2"><strong>Animal:</strong> {{animalData.number}} - {{animalData.name}}</div>
        <!-- <div class=" d-flex justify-content-end  border-bottom">
          <feather-icon @click="modalCase=7" icon="Edit2Icon" size="20" />
          <feather-icon class="" @click="modalTrashShow = !modalTrashShow" icon="TrashIcon" size="20" />
        </div> -->
        <div class="d-flex justify-content-between mt-3 ">
          <div class="ml-1">Vacunacion <p class="editModal"><a @click="navigateTo('/basicHome/Animals/Vaccines/'+currAnimal)">{{ vaccinations }}</a></p> </div> 
          <div class="mr-3">Desparacitaciones <p class="editModal"><a @click="navigateTo('/basicHome/Animals/Dewormings/'+currAnimal)">{{dewormings}}</a></p></div>
        </div>
        <div class="d-flex justify-content-between mt-1">
          <div class=" ml-1">Tratamientos <p class="editModal"><a @click="navigateTo('/basicHome/Animals/Treathments/'+currAnimal)">{{treathments}}</a></p></div>
           <div class=" mr-3">Alerta <p class="editModal"><a @click="navigateTo('/basicHome/Animals/Alerts/'+currAnimal)">{{ alerts }}</a></p></div>
        </div>
         <!-- <div class="d-flex justify-content-center mb-5 mt-3">
          <b-img src="@/assets/images/ganImage/UpoladImage.png" ></b-img>
         </div> -->
      </div>
      <!--////////////// -->
        <div v-if="modalCase==7">
          <div class="d-flex justify-content-end  ">
            <feather-icon @click="modalShow = !modalShow" icon="XIcon" size="20" />
          </div>
          <div v-if="!online" class="text-center">
            <b-img width="100px" 
            src="@/assets/images/ganImage/icons/offline.png"
            />
            <p><strong>Sin Conexión</strong></p>
          </div>
        </div>
        <!--////////////// -->
        <div v-if="modalCase == 4">
        <div class="d-flex justify-content-end  ">
          <feather-icon @click="modalShow = !modalShow" icon="XIcon" size="20" />
        </div>
        <div class="d-flex align-items-center justify-content-center subTitle pt-2">Datos Reproduccion</div>
        <div class="editAnimal mt-2"><strong>Animal:</strong> {{animalData.number}} - {{animalData.name}}</div>
          <div class="d-flex justify-content-between mt-3 " v-if="animalData.sex==true">
            <div class="ml-2">Reproduccion <p class="editModal"><a @click="navigateTo('/basicHome/AnimalsReproductive/'+currAnimal+'/8')">{{reproductive}}</a></p> </div> 
            <div class="mr-5 pr-3">Partos <p class="editModal"><a @click="navigateTo('/basicHome/AnimalsReproductive/'+currAnimal+'/4')">{{parts}}</a></p></div>
          </div>
          <div class="d-flex justify-content-between mt-1" v-if="animalData.sex==true">
            <div class=" ml-2">Abortos <p class="editModal"><a @click="navigateTo('/basicHome/AnimalsReproductive/'+currAnimal+'/5')">{{abortions}}</a></p></div>
            <div class=" mr-5">Palpaciones <p class="editModal"><a @click="navigateTo('/basicHome/AnimalsReproductive/'+currAnimal+'/6')">{{palpations}}</a></p></div>
          </div>
          <div class="d-flex justify-content-between mt-1" v-if="animalData.sex==true">
            <div class=" ml-2">Hijos <p class="editModal"><a @click="navigateTo('/basicHome/AnimalsChilds/'+currAnimal)">{{childs}}</a></p></div>
          </div>

          <div class="d-flex justify-content-between mt-1" v-if="animalData.sex==false">
            <div class=" ml-2">Andrología <p class="editModal"><a @click="navigateTo('/basicHome/AnimalsReproductive/'+currAnimal+'/7')">{{andrology}}</a></p></div>
          </div>
          <div class="d-flex justify-content-between mt-1" v-if="animalData.sex==false">
            <div class=" ml-2">Hijos<p class="editModal"><a @click="navigateTo('/basicHome/AnimalsChilds/'+currAnimal)">{{childs}}</a></p></div>
          </div>
      </div>
      <!--////////////// -->
        <div v-if="modalCase==6">
         <div class="d-flex justify-content-end  ">
          <feather-icon @click="modalShow = !modalShow" icon="XIcon" size="20" />
        </div>
        <div class="d-flex align-items-center justify-content-center subTitle pt-2">Datos Reproduccion</div>
        <div class="editAnimal mt-2"><strong>Animal:</strong> {{animalData.number}} - {{animalData.name}}</div>
          <div class="d-flex justify-content-center mt-2">

            <b-form-group class="w-25" label="Reproduccion" label-for="reproduction">
                <b-form-input id="reproduction"/>
            </b-form-group>
            <b-form-group class="w-75 ml-1" label="Partos" label-for="part">
                <b-form-input id="part" />
            </b-form-group>
          </div>
          <div class="d-flex justify-content-center mt-1">
            <b-form-group class="w-50" label="Abortos" label-for="abortion">
                <b-form-input id="abortion" />
            </b-form-group>
             <b-form-group class="w-50" label="Palpaciones" label-for="palpation">
                <b-form-input id="palpation" />
            </b-form-group>
          </div>
        <div class="d-flex justify-content-center  mt-2">
         <b-img src="@/assets/images/ganImage/UpoladImage.png" ></b-img></div>
         
         <div class="d-flex justify-content-center  mt-2 mb-1"><b-button class="bg-primary w-50"> Guardar</b-button></div>
        
        </div>
      <b-modal class="modal-lg" centered v-model="modalTrashShow" hide-footer hide-header>
        <div class="d-flex  align-items-end justify-content-end">
          <feather-icon @click="modalTrashShow = !modalTrashShow" icon="XIcon" size="20" />
        </div>
        <div class="d-flex flex-column align-items-center justify-content-center">
          <span class="deleteModal mt-2"> ¿Desea eliminar? </span>
          <b-button class="bg-deleteButton mt-2 mb-2">Eliminar</b-button>
        </div>
      </b-modal>

    </b-modal>
    <AddButton preTitle="Agregar Animal" goTo="basic-animalhome"/>
    <ControlMenu />
  </div>
</template>

<script>
import ControlMenu from '@/components/ControlMenu.vue'
import HeaderBar from '@/components/HeaderBar.vue'
import AddButton from '@/components/AddButton.vue'
import vSelect from 'vue-select'
import "vue-select/dist/vue-select.css";
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BAvatar, BBadge, BPagination, BFormGroup, BFormSelect, BFormCheckbox, BDropdown, BDropdownItem, BRow, BCol, BLink, BCardBody, BCard, BButton, BForm, BFormInput, BInputGroup, BImg, BCardTitle, BCardText,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import PlusButton2 from '@/components/PlusButton2.vue'
import store from '@/store/index'
import WheighinsLineChartVue from '../DataLog/Animal/WheighinsLineChart.vue';
import { VOffline } from 'v-offline';
export default {
  components: {
    BRow,
    BImg,
    BCol,
    BLink,
    BButton,
    BForm,
    BCardText,
    BCardTitle,
    BFormCheckbox,
    BInputGroup,
    BCardBody,
    BCard,
    VueGoodTable,
    vSelect,
    PlusButton2,
    ValidationProvider,
    ValidationObserver,
    BFormCheckbox,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    ControlMenu,
    HeaderBar,
    AddButton,
    WheighinsLineChartVue,
    VOffline
  },
  data() {
    return {
      fincaName:localStorage.getItem('currentFarmName'),
      online:false,
      currAmimal:0,
      currAnimalSex:false,
      pageLength: 10,
      dir: false,
      status1: null,
      status2: null,
      modalShow: false,
      modalCase: 0,
      editShow:false,
      modalTrashShow:false,
      columns: [
        {
          label:  'CODIGO',
          field:  'number',
          type:   'string'
        },  
        {
          label:  'ANIMAL',
          field:  'name',
          type:   'string'
        },
        {
          label:  'SEXO',
          field:  'sex',
          type:   'boolean'
        },
        {
          label:  'PESO',
          field:  'weight',
          type:   'number'
        },
        {
          label:  'EDAD',
          field:  'age',
          type:   'number'
        },

      ],
      rows: [],
      animalData:[],
      animal:{
        weight:0,
        age:0,
      },
      weighinsData:{
        labels:[],
        datasets: [
          { label:'Evolución de peso',
            backgroundColor: '#5E8F23',
            data:[]
          }
        ]
      },
      chartOptions:{
        responsive: true,
        maintainAspectRatio: false,
        backgroundColor: false,
        hover: {
          mode: 'label',
        },
        layout: {
          padding: {
            top: 0,
            bottom: 0,
            left: 0,
            right:20
          },
        },
        
        legend: {
          position: 'top',
          align: 'start',
          labels: {
            usePointStyle: true,
            padding: 25,
            boxWidth: 9,
          },
        },
      },
      weighins:{
        observations:'',
        animal_id:this.currAmimal,
        weight:0,
        date:''
      },
      searchTerm: '',
      vaccionations:0,
      dewormings:0,
      treathments:0,
      alerts:0,
      childs:0,
      reproductive:0,
      parts:0,
      abortions:0,
      palpations:0,
      andrology:0,
    }
  },
  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Current: 'light-primary',
        Professional: 'light-success',
        Rejected: 'light-danger',
        Resigned: 'light-warning',
        Applied: 'light-info',
        /* eslint-enable key-spacing */
      }

      return status => statusColor[status]
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
  },
  methods:{
    async fetchAnimals(config){
      if(this.online){
        console.log('Cargando animales');
        let farmId= localStorage.getItem('currentFarm');
        fetch(this.$apiUrl+"list/animals?recperpage=all&state=1&farm_id="+farmId, config)
          .then(response => response.json())
          .then(result => {
              console.log(result.animals);
              this.rows = result.animals.map(item => {return {id:item.id,number:item.number,name:item.name,sex:item.sex,weight:item.weight, age:item.age}});
              localStorage.setItem('animalsTemp',JSON.stringify(this.rows))
              console.log(this.rows);
          })
      }else{
        let localanimals= JSON.parse(localStorage.getItem('animalsTemp'));
        if(localanimals.length>0){
          this.rows=localanimals.map(item => {return {id:item.id,number:item.number,name:item.name,sex:item.sex,weight:item.weight, age:item.age}});
        }
        
      }
      
    },

    async fetchAnimalData(config){
      let id= this.currAnimal;
      fetch(this.$apiUrl+"view/animals/"+id, config)
        .then(response => response.json())
        .then(result => {
            console.log(result);
            this.animalData = result.animals;
            this.animal= result.animals;
            console.log(this.animalData);
        })
    },

    async fetchAnimalWheihins(config){
      let id= this.currAnimal;
        fetch(this.$apiUrl+"list/weighins?animal_id="+id+"&recperpage=all&order=date&ordertype=ASC", config)
        .then(response => response.json())
        .then(result => {
            console.log(result);
            this.weighinsData.labels= result.weighins.map(item => {return item.date});
            this.weighinsData.datasets[0].data = result.weighins.map(item => {return item.weight});
            console.log(this.weighinsData);
        })
    },

    async fetchAnimalVacinations(config){
      let id= this.currAnimal;
      let self=this;
      this.vaccinations=0;
      let vacs=[];
        fetch(this.$apiUrl+"list/VaccinationsByAnimals?animal_id="+id+"&recperpage=all", config)
        .then(response => response.json())
        .then(result => {
            console.log(result);
            result.VaccinationsByAnimals.map(item => {
              if(item.animal_id==id){
                
                vacs.push(item)
                console.log(vacs)
                this.vaccinations=(parseInt(vacs.length))
                console.log(this.vaccinations)
              }
            })

        })
    },
    async fetchAnimalDewormings(config){
      let id= this.currAnimal;
      let self=this;
      this.dewormings=0;
      let vacs=[];
        fetch(this.$apiUrl+"list/DemormerbyAnimals?animal_id="+id+"&recperpage=all", config)
        .then(response => response.json())
        .then(result => {
            console.log(result);
            result.DemormerbyAnimals.map(item => {
              if(item.animal_id==id){
                
                vacs.push(item)
                console.log(vacs)
                this.dewormings=(parseInt(vacs.length))
                console.log(this.dewormings)
              }
            })

        })
    },
    async fetchAnimalTreathments(config){
      let id= this.currAnimal;
      let self=this;
      this.treathments=0;
      let vacs=[];
        fetch(this.$apiUrl+"list/TreathmentsByAnimals?animal_id="+id+"&recperpage=all", config)
        .then(response => response.json())
        .then(result => {
            console.log(result);
            result.TreathmentsByAnimals.map(item => {
              if(item.animal_id==id){
                
                vacs.push(item)
                console.log(vacs)
                this.treathments=(parseInt(vacs.length))
                console.log(this.treathments)
              }
            })

        })
    },
    async fetchAnimalReproductive(config){
      let id= this.currAnimal;
      let self=this;
      this.reproductive=0;
      this.parts=0;
      this.abortions=0;
      this.palpations=0;
      this.andrology=0;
      let arrparts=[];
      let arrabortions=[];
      let arrpalpations=[];
      let arrreproductive=[];
        fetch(this.$apiUrl+"list/ReproductiveRecordsByAnimals?id="+id+"&recperpage=all", config)
        .then(response => response.json())
        .then(result => {
            console.log(result);
            result.ReproductiveRecordsByAnimals.map(item => {
              //Delivery
              if(item.type_id==4){
                arrparts.push(item)
                console.log(arrparts)
                this.parts=(parseInt(arrparts.length))
                console.log(this.parts)
              }else if(item.type_id==5){
                arrabortions.push(item)
                console.log(arrabortions)
                this.abortions=(parseInt(arrabortions.length))
                console.log(this.abortions)
              }else if(item.type_id==6){
                arrpalpations.push(item)
                console.log(arrpalpations)
                this.palpations=(parseInt(arrpalpations.length))
                console.log(this.palpations)
              }else if(item.type_id==7){
                arrreproductive.push(item)
                console.log(arrreproductive)
                this.reproductive=(parseInt(arrreproductive.length))
                this.andrology=(parseInt(arrreproductive.length))
                console.log(this.reproductive)
              }
              
            })

        })
    },
    async fetchChilds(config){
      let id= this.currAnimal;
      let self=this;
      this.childs=0;

      if(this.currAnimalSex==true){
        fetch(this.$apiUrl+"list/animals?mother="+id+"&recperpage=all", config)
        .then(response => response.json())
        .then(result => {
          console.log('childs')
          console.log(result);
          this.childs=(parseInt(result.animals.length))
        })
      }else{
        fetch(this.$apiUrl+"list/animals?father="+id+"&recperpage=all", config)
        .then(response => response.json())
        .then(result => {
          console.log('childs')
          console.log(result);
          this.childs=(parseInt(result.animals.length))
        })
      }
        
    },

    updateAnimal(){
      const token = localStorage.getItem("accessToken");
      const config = {headers: {"X-Authorization": `Bearer ${token}`}};
      let id= this.currAnimal;
      this.$http.post("edit/animals/"+id, this.animal, config).then(()=>{
        /* this.animal={
          weight:0,
          age:0,
          sex:0,
        } */

        this.$swal({
          title: 'Actualización de Animal',
          text: 'Se actualizó animal de manera satisfactoria',
          type: 'success',
          icon:'success',
          showCancelButton: false,
          confirmButtonColor:'#5E8F23',
          showCloseButton: true,
          showLoaderOnConfirm: false  
        }).then(function(){


        });
      }).catch(error => {
        console.log(error)
      });
    },

    insertWheigning(){
      const token = localStorage.getItem("accessToken");
      const config = {headers: {"X-Authorization": `Bearer ${token}`}};
      let id= this.currAnimal;
      this.$http.post("add/weighins/"+id, this.weighins, config).then(()=>{
        this.weighins={
          observations:'',
          animal_id:this.currAmimal,
          weight:0,
          date:''
        },

        this.$swal({
          title: 'Pesaje',
          text: 'Se insertó el peso del animal de manera satisfactoria',
          type: 'success',
          icon:'success',
          showCancelButton: false,
          confirmButtonColor:'#5E8F23',
          showCloseButton: true,
          showLoaderOnConfirm: false  
        }).then(function(){


        });
      }).catch(error => {
        console.log(error)
      });
    },

    showModal(params){
      if(this.online){
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
        console.log(params.row.id);
        console.log(params.row.sex);
        this.currAnimal=params.row.id;
        this.currAnimalSex=params.row.sex;
        console.log(this.currAnimal);
        this.fetchAnimalData(config);
        this.fetchAnimalWheihins(config);
        this.fetchAnimalVacinations(config);
        this.fetchAnimalDewormings(config);
        this.fetchAnimalTreathments(config);
        this.fetchChilds(config);
        this.fetchAnimalReproductive(config);
        this.modalShow=true;
        this.modalCase=0;
      }else{
        this.modalShow=true;
        this.modalCase=7;
      }
      
    },
    navigateTo(val){
      this.$router.push(val);
    },
    onConnectionChange(val){
      this.online=val;
      console.log(val);
    },
  },
  created() {
    const token = localStorage.getItem("accessToken");
    const config = {headers: {"X-Authorization": `Bearer ${token}`}};
    this.online=navigator.onLine;
    this.fetchAnimals(config);
  },
}
</script>
<style lang="scss">
body {
  background-color: white !important;
}
table{
    width: 100% !important;
  }
.subTitle {
  font-weight: 600;
  font-size: 23px;

}

.linkTitle {

  font-weight: 500;
  font-size: 14px;
  text-align: center;
  letter-spacing: 0.4px;
  color: #5E8F23;

}

.headTitle {
  font-weight: 600;
  font-size: 24px;
  color: #5E8F23;
}

thead{
  background-color: #5E8F23;
  text-align:center;
  color:#ffffff;
}
thead> tr{
  padding:5px;
}
.editAnimal {
  font-weight: 500;
  font-size: 18px;
}


.editModal {
  font-weight: 500;
  font-size: 18px;
}

span.text-center{
  display:flex;
  justify-content: center;
  text-align: center;
}


</style>